import React from 'react'
import { ALLIN_COLORS, getActionLabel, matrix } from './utils'


export const getActionColor = (action, availableActions, colors) => {
  const range = action.toLowerCase()


  const chartColors = colors.light

  if (ALLIN_COLORS.includes(range.toUpperCase())) return chartColors['allin']

  if (availableActions.includes('Fold') || availableActions.includes('FOLD')) {
    switch (range.toUpperCase()) {
      case 'OOR':
        return chartColors['oor']
      case 'FOLD':
        return chartColors['fold']
      case 'RAISE':
      case '3-BET':
      case '4-BET':
      case '5-BET':
        return chartColors['raise']
      case 'CALL':
      case 'LIMP':
        return chartColors['call']
      default:
        return chartColors['raise']
    }
  } else {
    switch (range) {
      case 'OOR':
        return chartColors['fold']

      case 'RAISE':
      case '3-BET':
      case '4-BET':
      case '5-BET':
        return chartColors['raise']
      case 'CALL':
      case 'LIMP':
        return chartColors['call']
      case range.includes('allin'):
        return chartColors['allin']
      default:
        return chartColors['raise']
    }
  }
}

export const getCombos = (matrixActions, range) => {
  const arr = matrixActions[range]

  const getCombosSum = (arr) => {
    let suitedSum = 0
    let pairSum = 0
    let unsuitedSum = 0
    for (let row = 0; row <= 12; row++) {
      for (let column = 0; column <= 12; column++) {
        if (column > row) {
          suitedSum += parseFloat(arr[matrix[`${column} ${row}`]])
        } else if (column === row) {
          pairSum += parseFloat(arr[matrix[`${column} ${row}`]])
        } else {
          unsuitedSum += parseFloat(arr[matrix[`${column} ${row}`]])
        }
      }
    }
    return pairSum * 6 + suitedSum * 4 + unsuitedSum * 12
  }

  const actionsToSum = { ...matrixActions }

  delete actionsToSum['OoR']

  Object.keys(actionsToSum).forEach((key) => {
    if (key.includes('Range')) delete actionsToSum[key]
  })

  // const totalCombos = Object.values(actionsToSum).reduce((acc, curr) => {
  //   return acc += curr.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
  // }, 0);
  let totalCombos = 0
  Object.values(actionsToSum).forEach((item, key) => {
    item.forEach((combo) => {
      totalCombos += parseFloat(combo)
    })
  })

  let result = getCombosSum(arr)

  // if there are `Out of Range` actions - add their combos sum to `Fold` action
  // if (Object.keys(matrixActions).includes("OoR") && range === "Fold") {
  //   const outOfRangeData = matrixActions["OoR"];
  //   const outOfRangeCombos = getCombosSum(outOfRangeData);
  //   result += outOfRangeCombos;
  // }

  const combos = result.toFixed(1)
  const percentage = ((combos / totalCombos) * 100).toFixed(1)

  // return `${percentage}% (${combos})`;
  return { percentage: percentage, combos: combos }
}

const ChartActions = ({
  matrixActions,
  isRFI,
  isSweeper = false,
  isGameOverMode = false,
  colors,
}) => {
  const actions = Object.keys(matrixActions)

  let actionsRowWidth

  const getActionWidth = (isFullWidth) => {
    return isFullWidth ? actionsRowWidth : actionsRowWidth / 2 - 5
  }

  return (
    <div
      style={{
        paddingVertical: '16px',
        paddingBottom: '5px',
        paddingTop: '8px',
        width: actionsRowWidth,
        alignSelf: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        display: 'flex',
        columnGap:'6px'
      }}
    >
      {actions.map((action, index) => {
        const { percentage, combos } = getCombos(matrixActions, action)
        if (action.toLocaleLowerCase() === 'oor') return null

        if (parseInt(combos) === 0) return null

        const actionColor = getActionColor(action, actions, colors)
        const isFullWidth =
          index % 2 === 0 &&
          index === actions.length - 1 - actions.includes('OoR')

        return (
          <div
            key={`action-${action}`}
            style={{
              backgroundColor: actionColor,
              padding: '10px 12px',
              borderRadius: '4px',
              marginBottom: '8px',
              width: getActionWidth(isFullWidth),
              flex: isSweeper ? 1 : 0,
              marginHorizontal: isSweeper ? 2 : 0,
              position: 'relative'
            }}
          >
            <div
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  fontSize: '18px',
                  lineHeight: '16px',
                  fontWeight: '500',
                  color: 'white',
                  marginVertical: "10px",
                }}
              >
                {getActionLabel(action)}
              </div>
              <div
                style={{
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                {isRFI && (
                  <div
                    style={{
                      fontSize: 11,
                      lineHeight: 16,
                      fontWeight: '400',
                      color: 'white',
                    }}
                  >
                    {percentage}%
                  </div>
                )}
                {isRFI && (
                  <div
                    style={{
                      fontSize: '11px',
                      lineHeight: '16px',
                      fontWeight: '400',
                      color: 'white',
                      marginLeft: '16px',
                      width: '40px',
                    }}
                  >
                    {combos}
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ChartActions
